import React, { useEffect, useState } from "react"
import "./style/swipe-hint.scss"

import { FiArrowLeft } from "@ng-mw/reol/icon-components/FiArrowLeft"
import touchPointer from "@resources/icons/touchPointer"
import Icon from "@ng-mw/reol/components/Icon"

interface SwipeHintProps {
    duration?: number
    delay?: number
    type?: "carousel" | "gallery" | "bundle"
    showOnlyOncePerSession?: boolean
}

function SwipeHint({
    duration = 6000,
    delay = 3000,
    type = "carousel",
    showOnlyOncePerSession = true,
}: SwipeHintProps) {
    const [visible, setVisible] = useState(false)
    const storageKey = `swipeHintShown-${type}`

    useEffect(() => {
        const hasShown = sessionStorage.getItem(storageKey)

        if (hasShown && showOnlyOncePerSession) return

        const showTimer = setTimeout(() => {
            setVisible(true)
            sessionStorage.setItem(storageKey, "true")

            const hideTimer = setTimeout(() => {
                setVisible(false)
            }, duration)

            return () => clearTimeout(hideTimer)
        }, delay)

        return () => clearTimeout(showTimer)
    }, [delay, duration, showOnlyOncePerSession, storageKey])

    if (!visible) return null

    return (
        <div className="swipe-hint">
            <div className="swipe-hint__arrow">
                <FiArrowLeft
                    width={20}
                    height={20}
                />
            </div>
            <div className="swipe-hint__hand">
                <Icon
                    icon={touchPointer}
                    size={{ width: "24px", height: "24px" }}
                />
            </div>
        </div>
    )
}

export default SwipeHint
